/**
 * Data-free URL helpers for categories and subcategories.
 *
 * This module deliberately imports NO dataset JSON so that client components
 * can build links without pulling the multi-megabyte category files into the
 * browser bundle. Server code should keep importing these from `@/lib/categories`,
 * which re-exports everything here.
 */

// Aliases for short URLs
export const CATEGORY_ALIASES: Record<string, string> = {
  fantasy: "fantasy-names",
  real: "real-names",
  places: "places-locations",
  "pop-culture": "pop-culture",
  other: "other-names",
  lore: "description-generators",
  descriptions: "description-generators",
};

export const REVERSE_CATEGORY_ALIASES: Record<string, string> = {
  "fantasy-names": "fantasy",
  "real-names": "real",
  "places-locations": "places",
  "pop-culture": "pop-culture",
  "other-names": "other-names",
  "description-generators": "description-generators",
};

export function getCategoryPrefix(fullSlug: string): string {
  return REVERSE_CATEGORY_ALIASES[fullSlug] || fullSlug;
}

export function getFullCategorySlug(prefix: string): string {
  return CATEGORY_ALIASES[prefix] || prefix;
}

export function getCategoryUrl(categorySlug: string): string {
  const prefix = getCategoryPrefix(categorySlug);
  return `/${prefix}`;
}

export function getSubcategoryUrl(categorySlug: string, subcategorySlug: string): string {
  const prefix = getCategoryPrefix(categorySlug);
  return `/${prefix}/${subcategorySlug}`;
}
